module.exports = __webpack_public_path__ + "static/media/vinylot.0be81b97.ttf";